class componentWishlist extends HTMLElement {
  constructor() {
    super();
    this.customerId = parseInt(this.getAttribute("data-customer")) || null;
    this.baseURL = "https://back-in-stock-backend-prod-b3c5b0b315ec.herokuapp.com/wishlist/api";
    this.token = "59b3a21adc45254d9e6f17c46f9052057ce63a2517612b046b021e48803505102decd6e6235d15f26b756bc962f5a32d424c";
  }

  async connectedCallback() {
    const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];

    if (wishlistData.length === 0) {
      const wishlist = this.querySelector(".wishlist-products");
      wishlist.classList.remove("loading");
      const messageEmptyList = this.getAttribute("data-message-empty-list") || "Sua lista de desejos está vazia.";
      wishlist.innerHTML = `<div style='width: 100%; display: flex; justify-content: center; align-items: center; min-height: 100px'><p>${messageEmptyList}</p></div>`;

      return;
    }

    if (this.customerId) {
      const product = wishlistData.find((item) => item.customer === null);
      if (product && !product.customer && product.guest_id) {
        this._transferGuestWishesToCustomer();
      } else {
        this.verifyWishlist();
      }
    } else {
      this.loadPage();
    }
  }

  async verifyWishlist() {
    try {
      await this.getWishlistUser();
      await this.removeDuplicates();
      this.loadPage();
    } catch (error) {
      console.error("Erro ao verificar a wishlist:", error);
    }
  }

  async removeDuplicates() {
    const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
    const uniqueItems = new Map();
    const listIdsDuplicate = [];

    wishlistData.forEach((item) => {
      if (uniqueItems.has(item.variant_id)) {
        listIdsDuplicate.push(item.id);
      } else {
        uniqueItems.set(item.variant_id, item);
      }
    });

    if (listIdsDuplicate.length === 0) {
      return this.loadPage();
    }

    await Promise.all(listIdsDuplicate.map((id) => this.removeProductInWishlist(id)));
    const newWishlistData = Array.from(uniqueItems.values());
    localStorage.setItem("wishlist", JSON.stringify(newWishlistData));
  }

  async loadPage() {
    const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
    const wishlist = this.querySelector(".wishlist-products");
    if (wishlistData.length !== 0) {
      let compareProducts = [];
      const wishlistPromises = wishlistData
        .filter((element) => {
          if (!compareProducts.find((id) => id === element.product_id && element.variant_id)) {
            compareProducts.push(element.product_id);
            return element.variant_id;
          }
        })
        .map((element) => this.getCardProduct(element.product_handle, element.variant_id));

      try {
        const results = await Promise.all(wishlistPromises);
        wishlist.innerHTML = "";

        const fragment = document.createDocumentFragment();
        results.forEach((element) => {
          const productItem = document.createElement("div");
          productItem.classList.add("grid__item");
          productItem.appendChild(element);
          fragment.appendChild(productItem);
        });
        wishlist.appendChild(fragment);
        wishlist.classList.remove("loading");
      } catch (error) {
        console.error("Erro ao carregar a wishlist:", error);
      }
    }
  }

  async getCardProduct(productHandle, variantId) {
    const response = await fetch(`/products/${productHandle}?variant=${variantId}&view=card`);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, "text/html");
    return html.querySelector(".product-card-snippet");
  }

  async getWishlistUser() {
    const headersRequest = new Headers();
    headersRequest.append("Origin", "insiderstore.com.br");

    const requestOptions = {
      method: "GET",
      headers: headersRequest,
      redirect: "follow",
    };

    let response = {};

    await fetch(`${this.baseURL}?customer_id=${this.customerId}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        localStorage.setItem("wishlist", JSON.stringify(result));
      })
      .catch((error) => console.error(error));

    return response;
  }

  async removeProductInWishlist(wishlistId) {
    const myHeaders = new Headers();
    myHeaders.append("Origin", "insiderstore.com.br");
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      wish: wishlistId,
    });

    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    await fetch("https://back-in-stock-backend-prod-b3c5b0b315ec.herokuapp.com/wishlist/api", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        wishlistAlert("Produto removido da <a href='/pages/wishlist?view=wishlist'>lista de desejos!</a>");
        if (window.location.href.includes("wishlist")) {
          window.location.reload();
        }
      })
      .catch((error) => console.error(error));

    return true;
  }

  async _transferGuestWishesToCustomer() {
    const myHeaders = new Headers({
      Authorization: this.token,
      Origin: "insiderstore.com.br",
    });

    const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
    const guestId = wishlistData.find((item) => item.customer === null).guest_id;
    if (!guestId || !this.customerId) return;
    try {
      await fetch(`${this.baseURL}/transfer-guest-wishes?guest_id=${guestId}&customer_id=${this.customerId}`, {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      });
      this.verifyWishlist();
    } catch (error) {
      console.error(error.message);
    }
  }
}

customElements.get("component-wishlist") || customElements.define("component-wishlist", componentWishlist);

customElements.get("button-wishlist") ||
  customElements.define(
    "button-wishlist",
    class extends componentWishlist {
      constructor() {
        super();
        this.variantId = parseInt(this.getAttribute("data-variant-id")) || null;
        this.customerId = parseInt(this.getAttribute("data-customer-id")) || null;
        this.button = this.querySelector(".button-wishlist");
        this.addEventListener("click", this.handleClick.bind(this));
        this.kitSelectoresActions = this.closest(".kit-variant-selector__actions-wishlist");

        this.popup = this.getAttribute("data-display-popup") || false;
        if (this.popup) {
          this.backgroundImageModal = this.getAttribute("data-background-image-modal") || false;
          this.backgroundColorModal = this.getAttribute("data-background-color-modal") || "#000";
          this.titleModal = this.getAttribute("data-title-modal") || "";
          this.messageModalText = this.getAttribute("data-message-modal-text") || "";
          this.messageModalButton = this.getAttribute("data-message-modal-button") || "";
          this.urlModalButton = this.getAttribute("data-url-modal-button") || "";
          this.timeDisplayPopup = parseInt(this.getAttribute("data-time-display-popup")) * 100 || 300;
        }
      }

      connectedCallback() {
        this.checkIfProductIsInWishlist();
      }

      checkIfProductIsInWishlist() {
        const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
        const isAlreadyInWishlist = wishlistData.find((item) => item.variant_id === this.variantId);
        if (isAlreadyInWishlist) {
          this.button.classList.add("active");
        } else {
          if (wishlistData.lenght > 0) this.guestId = wishlistData.find((item) => item.guest_id).guest_id;
        }
        this.button.classList.remove("hidden");
      }

      displayPopup() {
        const modal = document.createElement("div");
        modal.setAttribute("id", `modal-wishlist-${this.variantId}`);
        modal.classList.add("modal-wishlist");
        modal.setAttribute("data-time", this.timeDisplayPopup);

        const modalContent = document.createElement("div");
        modalContent.classList.add("modal-content");
        modalContent.classList.add(`${this.getAttribute("data-width-modal")}`);

        if (this.backgroundImageModal) {
          modalContent.style.backgroundImage = `url('${this.backgroundImageModal}')`;
        } else {
          modalContent.style.backgroundColor = this.backgroundColorModal;
        }

        const modalClose = document.createElement("span");
        modalClose.classList.add("close-popup-wishlist");
        modalClose.innerHTML = "&times;";

        modal.addEventListener("click", function (e) {
          const element = e.target.classList;
          const time = parseInt(document.querySelector(".modal-wishlist").getAttribute("data-time"));
          if (element.contains("modal-wishlist") || element.contains("close-popup-wishlist")) {
            modal.animate([{ opacity: 1 }, { opacity: 0 }], {
              duration: time,
              fill: "forwards",
            });
            setTimeout(() => {
              modal.remove();
            }, time);
          }
        });

        const modalTitle = document.createElement("h3");
        modalTitle.innerHTML = this.titleModal;

        const modalText = document.createElement("p");
        modalText.innerHTML = this.messageModalText;

        const modalButton = document.createElement("a");
        modalButton.classList.add("button");
        modalButton.innerHTML = this.messageModalButton;
        modalButton.href = this.urlModalButton;

        modalContent.appendChild(modalClose);
        modalContent.appendChild(modalTitle);
        modalContent.appendChild(modalText);
        modalContent.appendChild(modalButton);
        modal.appendChild(modalContent);

        document.body.appendChild(modal);

        modal.animate([{ opacity: 0 }, { opacity: 1 }], { duration: this.timeDisplayPopup, fill: "forwards" });
      }

      async handleClick() {
        this.classList.add("loading");
        if (!this.customerId && this.popup && !this.button.classList.contains("active")) {
          this.displayPopup();
        }

        const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
        const isAlreadyInWishlist = wishlistData.some((item) => item.variant_id === this.variantId);
        let updatedWishlistData;

        if (isAlreadyInWishlist) {
          updatedWishlistData = wishlistData.filter((item) => item.variant_id !== this.variantId);
          const itemRemove = wishlistData.filter((item) => item.variant_id === this.variantId);
          this.removeProductInWishlist(itemRemove[0].id);
          this.button.classList.remove("active");
        } else {
          const response = await this.addProductInWishlist(wishlistData);
          if (!response.variant_id) return;
          updatedWishlistData = [...wishlistData, response];
          this.button.classList.add("active");
        }

        if (wishlistData != []) localStorage.setItem("wishlist", JSON.stringify(updatedWishlistData));

        this.classList.remove("loading");
      }

      async addProductInWishlist(wishlistData) {
        const headersRequest = new Headers();
        headersRequest.append("Origin", "insiderstore.com.br");
        headersRequest.append("Content-Type", "application/json");

        let bodyJson = { variant: this.variantId };

        if (wishlistData.length > 0 && wishlistData[0].guest_id) bodyJson.guest_id = wishlistData[0].guest_id;
        if (this.customerId) bodyJson.customer_id = this.customerId;

        const bodyRequest = JSON.stringify(bodyJson);
        const requestOptions = {
          method: "POST",
          headers: headersRequest,
          body: bodyRequest,
          redirect: "follow",
        };

        let response = {};

        await fetch(this.baseURL, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            response = result;
            wishlistAlert("Produto adicionado à <a href='/pages/wishlist?view=wishlist'>lista de desejos!</a>");
          })
          .catch((error) => console.error(error));

        return response;
      }
    }
  );

function wishlistAlert(message) {
  const alertElement = document.querySelector(".wishlist-alert");
  alertElement.innerHTML = message;
  alertElement.classList.add("show");
  let timeoutId;

  const hideAlert = () => {
    alertElement.className = alertElement.className.replace("show", "");
  };

  const startTimeout = () => {
    timeoutId = setTimeout(hideAlert, 5000);
  };

  const cancelTimeout = () => {
    clearTimeout(timeoutId);
  };
  alertElement.addEventListener("mouseover", cancelTimeout);
  alertElement.addEventListener("mouseout", startTimeout);

  startTimeout();
}
